import Nullstack from 'nullstack';
export default function IconPolygonOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-polygon-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "19",
    cy: "8",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "5",
    cy: "11",
    r: "2"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "19",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M6.5 9.5l1.546 -1.311"
  }), "   ", Nullstack.element("path", {
    d: "M14 5.5l3 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M18.5 10l-1.185 3.318m-1.062 2.972l-.253 .71"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 17.5l-7 -5"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}